import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../apps/gs-2.0/src/environments/environment';
import { RestfulApiService } from '../restful-api.service';

export interface SignResponse {
  signature: string;
}

@Injectable({
  providedIn: 'root'
})
export class SignatureService {
  private readonly generateEndpoint = '/v1/signature/generate';

  constructor(private apiService: RestfulApiService) {}

  getSignature(body: object): Observable<SignResponse> {
    return this.apiService.post(
      this.generateEndpoint,
      body,
      { headers: { 'x-api-key': environment.fund.signatureApiKey } }
    ) as Observable<SignResponse>;
  }
}
